jQuery(document).ready(function ($) {
  $(document).on('click', '.mobile-menu-toggle', function (e) {
    e.preventDefault()
    $(this).toggleClass('is-active')
    $('body').toggleClass('mobile-menu-show')
    $('html').toggleClass('mobile-menu-show')
  })
  $('.menu-item.menu-item-has-children > a').append(
    '<span class="btn-toggle-submenu"><svg width="14" height="14" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00001 7.71299L13.01 1.70299L11.597 0.287994L7.00001 4.88799L2.40401 0.287994L0.990005 1.70199L7.00001 7.71299Z" fill="currentColor"/></svg>\n</span>'
  )
  $(document).on('click', '.menu-item-has-children .btn-toggle-submenu', function (e) {
    e.stopPropagation()
    e.preventDefault()
    $(this).toggleClass('is-active')
    $(this).parents('.menu-item-has-children').toggleClass('is-active')
  })

  $('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $submenu = $(this).siblings('.sub-menu')
    const isVisible = $submenu.is(':visible')

    $('.menu-item-has-children > a').removeClass('active')
    $('.sub-menu').slideUp('fast')

    if (!isVisible) {
      $(this).addClass('active')
      $submenu.slideDown('fast')
    }
  })

  $(document).on('click', function (e) {
    const $container = $('.menu-item-has-children')

    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
      $('.menu-item-has-children > a').removeClass('active')
      $('.sub-menu').slideUp('fast')
    }
  })
})
